
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Calendar_Buttons.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';
import "../../SelectBox/SelectBox";

import "../WebCalendarTypes"
import FloatingMenu from '../../Floating/Menu';
import { WebcalendarTypes } from "../WebCalendarTypes";






type viewbehaviour = "calendar" | "timeline" | "list";
class Calendar_Buttons extends compose(_WidgetBaseSP) {
    templateString: any = template;

    //// Nodes ---------------------------------------------------STRT
    private navigationArrowsContainer: HTMLButtonElement;
    private previousButton: HTMLButtonElement;
    private nextButton: HTMLButtonElement;
    private todayButton: HTMLButtonElement;
    //private dayButton: HTMLButtonElement;
    //private threeDaysButton: HTMLButtonElement;
    //private weekButton: HTMLButtonElement;
    //private twoWeekButton: HTMLButtonElement;
    //private monthButton: HTMLButtonElement;
    private customButtonsContainer: HTMLElement;

    private txtRangeCurrent: HTMLElement;
    private txtRangeEnd: HTMLElement;
    private txtRangeStart: HTMLElement;
    private rangeNavigationContainer: HTMLElement;
    private nextRangeContainer: HTMLElement;
    private previousRangeContainer: HTMLElement;
    private nextRangeButton: HTMLButtonElement;
    private previousRangeButton: HTMLButtonElement;
    private rangePositionContainer: HTMLButtonElement;
    private rangeCenterContainer: HTMLButtonElement;
    private rangeCenterMobile: HTMLButtonElement;
    private rangeCenterRight: HTMLButtonElement;
    private rangeCenterLeft: HTMLButtonElement;

    private viewBehaviour: viewbehaviour = "calendar";

    private btnViewSelectMenu: HTMLElement;
    private btnViewSelectLabel: HTMLElement;
    private responsiveViewSelectContainer: HTMLElement;
    private viewSelectMenu: MdsLax<InstanceType<typeof FloatingMenu>>;

    private currentMode: WebcalendarTypes.WebCalendar_ViewModes;

    //// Nodes ---------------------------------------------------END
    //// preperties ----------------------------------------------START
    private allButtonsRegistry: Array<WebcalendarTypes.WebCalender_ViewButton>;

    private allowDay: boolean = true;
    private allow3days: boolean = true;
    private allowWeek: boolean = true;
    private allow2weeks: boolean = true;
    private allowMonth: boolean = true;
    private allowYear: boolean = false;
    private allowTimelineYear: boolean = false;
    private allowTimelineOverview: boolean = false;
    private allowTimelineDay: boolean = false;
    private allowTimelineDetail: boolean = false;
    private allowListView: boolean = false;
    private allViewsDisabled: boolean = false;


    private _rangeCurrentIndex: number = 0;
    private _rangeLimitMin: number = 0;
    private _rangeLimitMax: number = 0;

    allowView(viewName: WebcalendarTypes.WebCalendar_ViewModes | "all", allow: boolean = true) {
        switch (viewName) {
            case WebcalendarTypes.WebCalendar_ViewModes.day:
                this.allowDay = allow;
                break;
            case WebcalendarTypes.WebCalendar_ViewModes.threeDays:
                this.allow3days = allow;
                break;
            case WebcalendarTypes.WebCalendar_ViewModes.week:
                this.allowWeek = allow;
                break;
            case WebcalendarTypes.WebCalendar_ViewModes.twoWeeks:
                this.allow2weeks = allow;
                break;
            case WebcalendarTypes.WebCalendar_ViewModes.month:
                this.allowMonth = allow;
                break;
            case WebcalendarTypes.WebCalendar_ViewModes.year:
                this.allowYear = allow;
                break;
            case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:
                this.allowTimelineDetail = allow;
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:
                this.allowTimelineYear = allow;
                break;
            case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:
                this.allowTimelineOverview = allow;
                break;
            case WebcalendarTypes.WebCalendar_ViewModes.timelineDay:
                this.allowTimelineDay = allow;
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.listView:
                this.allowListView = allow;
                break;

            case "all":

                this.allowView(WebcalendarTypes.WebCalendar_ViewModes.day, allow);
                this.allowView(WebcalendarTypes.WebCalendar_ViewModes.threeDays, allow);
                this.allowView(WebcalendarTypes.WebCalendar_ViewModes.week, allow);
                this.allowView(WebcalendarTypes.WebCalendar_ViewModes.twoWeeks, allow);
                this.allowView(WebcalendarTypes.WebCalendar_ViewModes.month, allow);
                this.allowView(WebcalendarTypes.WebCalendar_ViewModes.year, allow && this.hasFeature("webcalendar/yearviews"));
                this.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineYear, allow && this.hasFeature("webcalendar/yearviews"));
                this.allowView(WebcalendarTypes.WebCalendar_ViewModes.listView, allow && this.hasFeature("webcalendar/listview"));
                this.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineOverview, allow && this.hasFeature("webcalendar/timeline"));
                this.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineDetail, allow && this.hasFeature("webcalendar/timeline"));
                this.allowView(WebcalendarTypes.WebCalendar_ViewModes.timelineDay, allow && this.hasFeature("webcalendar/timeline"));
                break;
        }

        this.allViewsDisabled =
            !this.allowDay &&
            !this.allow3days &&
            !this.allowWeek &&
            !this.allow2weeks &&
            !this.allowMonth &&
            !this.allowYear &&
            !this.allowTimelineDay &&
            !this.allowTimelineDetail &&
            !this.allowTimelineOverview &&
            !this.allowTimelineYear;

        this.hideNode(this.btnViewSelectMenu, this.allViewsDisabled);
    }

    private _onClick_Today(evt: MouseEvent) {
        
        this.emit("viewChange", "today");

        //this.setMode(WebcalendarTypes.WebCalendar_ViewModes.day, false);
    }
    private _onClick_Reload(evt: MouseEvent) {
        
        this.emit("viewChange", "reload");
        this.disableNode(this.domNode);
        setTimeout(lang.hitch(this, function () { this.disableNode(this.domNode, false); }), 1000);
        //this.setMode(WebcalendarTypes.WebCalendar_ViewModes.day, false);
    }

    private _onClick_Next(evt: MouseEvent) {

        if (!this.hasRange()) {
            this.emit("viewChange", "next");
        }
        else {
            this.disableNode(this.domNode);
            this.emit("viewChange", "stepForward");
        }
        
    }
    private _onClick_Previous(evt: MouseEvent) {

        if (!this.hasRange()) {
            this.emit("viewChange", "previous");
        }
        else {
            this.disableNode(this.domNode);
            this.emit("viewChange", "stepBackward");
        }

    }
    private _onClick_NextRange(evt: MouseEvent) {
        
        if (this._rangeCurrentIndex == this._rangeLimitMax) {
            this.disableNode(this.domNode);
            this.emit("viewChange", "nextRange");
        }
        else {
            this._rangeCurrentIndex = this._rangeLimitMax;
            this.emit("viewChange", "rangeMax");
        }

        this.drawRangePosition();

        
    }
    private _onClick_PreviousRange(evt: MouseEvent) {

        if (this._rangeCurrentIndex == this._rangeLimitMin) {
            this.disableNode(this.domNode);
            this.emit("viewChange", "previousRange");
        }
        else {
            this._rangeCurrentIndex = this._rangeLimitMin;
            this.emit("viewChange", "rangeMin");
        }

        this.drawRangePosition();

    }

    setRangeLabels(txtCurrentRange: string, txtRangeStart: string, txtRangeEnd: string) {

        //console.trace(this.id + " setRangeLabels", txtCurrentRange);
        //this.UiModder.domClass.remove(this.txt)
        if (txtCurrentRange) {
            this.txtRangeCurrent.innerHTML = txtCurrentRange;
            // TODO: highlight-Klasse toggeln (kurzes Aufleuchten damits der User besser sieht)

        }


        this.hideNode(this.txtRangeCurrent, !txtCurrentRange);

        if (txtRangeStart) {
            this.txtRangeStart.innerHTML = txtRangeStart;
        }
        if (txtRangeEnd) {
            this.txtRangeEnd.innerHTML = txtRangeEnd;
        }

    }

    hasRange(): boolean {
        return this._rangeLimitMin != this._rangeLimitMax &&
            this._rangeLimitMin < this._rangeLimitMax;
    }

    setupRange(stepsBack: number, stepsForward: number, currentIndex: number = 0, txtCurrentRange?: string, txtRangeStart?: string, txtRangeEnd?: string) {
        this.disableNode(this.domNode, false);

        if (typeof (stepsBack) != "number") stepsBack = this._rangeLimitMin;
        if (typeof (stepsForward) != "number") stepsForward = this._rangeLimitMax;

        this.setRangeLabels(txtCurrentRange, txtRangeStart, txtRangeEnd);

        this._rangeCurrentIndex = currentIndex;
        if (stepsBack < 0) stepsBack = -1 * stepsBack;
        this._rangeLimitMin = -1 * stepsBack; // muss negativer Wert sein, 0 ist immer die Mitte
        this._rangeLimitMax = stepsForward;

        let hasRange = this.hasRange();

        
        this.UiModder.domClass.toggle(this.rangeNavigationContainer, "activeRange", hasRange);
        
        this.hideNode(this.nextRangeContainer, !hasRange);
        this.hideNode(this.previousRangeContainer, !hasRange);
        //this.hideNode(this.txtRangeCurrent, !hasRange);

        this.drawRangePosition();        
    }

    private drawRangePosition() {
        this.UiModder.domConstruct.empty(this.rangePositionContainer);
        this.UiModder.domConstruct.empty(this.rangeCenterRight);
        this.UiModder.domConstruct.empty(this.rangeCenterLeft);
        this.UiModder.domConstruct.empty(this.rangeCenterMobile);



        if (!this.hasRange()) {
            this.hideNode(this.rangePositionContainer);

            this.disableNode(this.previousButton, false);
            this.disableNode(this.nextButton, false);

            return;
        }

        //this.disableNode(this.previousButton, this._rangeCurrentIndex == this._rangeLimitMin);
        //this.disableNode(this.nextButton, this._rangeCurrentIndex == this._rangeLimitMax);

        //this.hideNode(this.rangePositionContainer, false);
        this.hideNode(this.rangeCenterLeft);
        this.hideNode(this.rangeCenterRight);
        this.hideNode(this.rangeCenterMobile);
        for (let position = this._rangeLimitMin; position <= this._rangeLimitMax; position++) {

            if (position < this._rangeCurrentIndex) {
                let icon = this.createFontawesomeIcon("fas fa-circle pL2TXT", "", this.rangeCenterLeft);
                this.hideNode(this.rangeCenterLeft, false);
            } else if (position > this._rangeCurrentIndex) {
                let icon = this.createFontawesomeIcon("fas fa-circle pL2TXT", "", this.rangeCenterRight);
                this.hideNode(this.rangeCenterRight, false);
            } else if (position == this._rangeCurrentIndex) {
                let icon = this.createFontawesomeIcon("fas fa-circle primaryTXT", "", this.rangeCenterMobile);
                this.hideNode(this.rangeCenterMobile, false);
            }
            //let icon = this.UiModder.domConstruct.create("span", {
            //    className: "",
            //    innerHTML: "•",
            //    style: {
            //        "padding": "1px",
            //        "maxHeight": "5px",
            //        "overflow": "visible",
            //        "pointerEvents": "none",
            //       "lineHeight": "10px" // magic numbers, sollte so nicht bleiben...
            //    }
            //}, this.rangePositionContainer);

        //    this.UiModder.domClass.toggle(icon, "tertiaryTXT", position != this._rangeCurrentIndex);
        //    this.UiModder.domClass.toggle(icon, "primaryTXT", position == this._rangeCurrentIndex);
        }
        this.updateTopbarMargin();
    }


    setMode(mode: WebcalendarTypes.WebCalendar_ViewModes, emit: boolean = true) {

        let newBehaviour: viewbehaviour = "calendar";
        let label = "?";

        
        switch (mode) {
            case WebcalendarTypes.WebCalendar_ViewModes.day:
                label = this.translate("moreCoreCalendar__calendarButtonsLabel_day");
                break;
            case WebcalendarTypes.WebCalendar_ViewModes.threeDays:
                label = this.translate("moreCoreCalendar__calendarButtonsLabel_3days");

                break;
            case WebcalendarTypes.WebCalendar_ViewModes.week:
                label = this.translate("moreCoreCalendar__calendarButtonsLabel_week");
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.twoWeeks:
                label = this.translate("moreCoreCalendar__calendarButtonsLabel_2weeks");
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.month:
                label = this.translate("moreCoreCalendar__calendarButtonsLabel_month");
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.year:
                label = this.translate("moreCoreCalendar__calendarButtonsLabel_year");
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.listView:
                label = this.translate("moreCoreCalendar__calendarButtonsLabel_listview");
                newBehaviour = "list";
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:
                newBehaviour = "timeline";
                label = this.translate("moreCoreCalendar__calendarButtonsLabel_TimelineYear");
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:
                newBehaviour = "timeline";
                label = this.translate("moreCoreCalendar__calendarButtonsLabel_TimelineOverview");
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:
                newBehaviour = "timeline";
                label = this.translate("moreCoreCalendar__calendarButtonsLabel_TimelineDetail");
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.timelineDay:
                newBehaviour = "timeline";
                label = this.translate("moreCoreCalendar__calendarButtonsLabel_TimelineDay");
                break;

          
        }

        if (this.viewBehaviour != newBehaviour) {
            this.viewBehaviour = newBehaviour;
        } 
        if (this.currentMode != mode) {

            this.currentMode = mode;
            if (emit !== false) {
                this.emit("viewChange", mode);
            }
            this.UiModder.domAttr.set(this.btnViewSelectLabel, "innerHTML", label);

            this.updateTopbarMargin();

        }

        
    }

    private _onClick_Day(evt: MouseEvent, emit: boolean = true) {
        this.setMode(WebcalendarTypes.WebCalendar_ViewModes.day, emit);

    }
    private _onClick_3Days(evt: MouseEvent, emit: boolean = true) {
        this.setMode(WebcalendarTypes.WebCalendar_ViewModes.threeDays, emit);
    }
   
    private _onClick_Week(evt: MouseEvent, emit: boolean = true) {
        this.setMode(WebcalendarTypes.WebCalendar_ViewModes.week, emit);
    }
    private _onClick_2Weeks(evt: MouseEvent, emit: boolean = true) {
        this.setMode(WebcalendarTypes.WebCalendar_ViewModes.twoWeeks, emit);
    }
    private _onClick_Month(evt: MouseEvent, emit: boolean = true) {
        this.setMode(WebcalendarTypes.WebCalendar_ViewModes.month, emit);
    }
    private _onClick_Year(evt: MouseEvent, emit: boolean = true) {
        this.setMode(WebcalendarTypes.WebCalendar_ViewModes.year, emit);
    }
    private _onClick_TimelineYear(evt: MouseEvent, emit: boolean = true) {
        this.setMode(WebcalendarTypes.WebCalendar_ViewModes.timelineYear, emit);
    }
    private _onClick_TimelineOverview(evt: MouseEvent, emit: boolean = true) {
        this.setMode(WebcalendarTypes.WebCalendar_ViewModes.timelineOverview, emit);
    }
    private _onClick_TimelineDetail(evt: MouseEvent, emit: boolean = true) {
        this.setMode(WebcalendarTypes.WebCalendar_ViewModes.timelineDetail, emit);
    
    }
    private _onClick_TimelineDay(evt: MouseEvent, emit: boolean = true) {
        this.setMode(WebcalendarTypes.WebCalendar_ViewModes.timelineDay, emit);
    }
    private _onClick_LisView(evt: MouseEvent, emit: boolean = true) {
        this.setMode(WebcalendarTypes.WebCalendar_ViewModes.listView, emit);
    }
    private _onClick_ViewSelectMenu(evt: MouseEvent) {
        if (this.allViewsDisabled) return;

        let menu = new FloatingMenu();


        if (this.allowListView) {
            menu.addEntry({
                name: WebcalendarTypes.WebCalendar_ViewModes.listView,
                label: this.translate("moreCoreCalendar__calendarButtonsLabel_listview"),
                callback: lang.hitch(this, this._onClick_LisView),
                enabled: this.currentMode != WebcalendarTypes.WebCalendar_ViewModes.listView,
                icon: this.currentMode == WebcalendarTypes.WebCalendar_ViewModes.listView ? "fas fa-check" : "",
                //    groupname: WebcalendarTypes.WebCalendar_ViewModes.listView,
                //    heading: 
            }, WebcalendarTypes.WebCalendar_ViewModes.listView);
        }


        if (this.allowDay) {
            menu.addEntry({
                name: WebcalendarTypes.WebCalendar_ViewModes.day,
                label: this.translations["moreCoreCalendar__calendarButtonsLabel_day"],
                callback: lang.hitch(this, this._onClick_Day),
                enabled: this.currentMode != "day",
                icon: this.currentMode == "day" ? "fas fa-check" : ""
            }, "calendar");
        }

        if (this.allow3days /*&& this.viewBehaviour == "calendar"*/ ) {
            menu.addEntry({
                name: WebcalendarTypes.WebCalendar_ViewModes.threeDays,
                label: this.translations["moreCoreCalendar__calendarButtonsLabel_3days"],
                callback: lang.hitch(this, this._onClick_3Days),
                enabled: this.currentMode != "3days",
                icon: this.currentMode == "3days" ? "fas fa-check" : ""
            }, "calendar");
        }

        if (this.allowWeek) {
            menu.addEntry({
                name: WebcalendarTypes.WebCalendar_ViewModes.week,
                label: this.translations["moreCoreCalendar__calendarButtonsLabel_week"],
                callback: lang.hitch(this, this._onClick_Week),
                enabled: this.currentMode != "week",
                icon: this.currentMode == "week" ? "fas fa-check" : ""
            }, "calendar");
        }

        if (this.allow2weeks) {
            menu.addEntry({
                name: WebcalendarTypes.WebCalendar_ViewModes.twoWeeks,
                label: this.translations["moreCoreCalendar__calendarButtonsLabel_2weeks"],
                callback: lang.hitch(this, this._onClick_2Weeks),
                enabled: this.currentMode != "2weeks",
                icon: this.currentMode == "2weeks" ? "fas fa-check" : ""
            }, "calendar");
        }

        if (this.allowMonth) {
            menu.addEntry({
                name: WebcalendarTypes.WebCalendar_ViewModes.month,
                label: this.translate("moreCoreCalendar__calendarButtonsLabel_month"),
                callback: lang.hitch(this, this._onClick_Month),
                enabled: this.currentMode != "month",
                icon: this.currentMode == "month" ? "fas fa-check" : ""
            }, "calendar");
        }
         if (this.allowYear) {
            menu.addEntry({
                name: WebcalendarTypes.WebCalendar_ViewModes.year,
                label: this.translate("moreCoreCalendar__calendarButtonsLabel_year"),
                callback: lang.hitch(this, this._onClick_Year),
                enabled: this.currentMode != "year",
                icon: this.currentMode == "year" ? "fas fa-check" : ""
            }, "calendar");
        }



          if (this.allowTimelineYear) {
            menu.addEntry({
                name: WebcalendarTypes.WebCalendar_ViewModes.timelineYear,
                label: this.translate("moreCoreCalendar__calendarButtonsLabel_year"),
                callback: lang.hitch(this, this._onClick_TimelineYear),
                enabled: this.currentMode != WebcalendarTypes.WebCalendar_ViewModes.timelineYear,
                icon: this.currentMode == WebcalendarTypes.WebCalendar_ViewModes.timelineYear ? "fas fa-check" : "far fa-calendar"
            }, "timeline");
        }


       
        if (this.allowTimelineOverview) {
            menu.addEntry({
                name: WebcalendarTypes.WebCalendar_ViewModes.timelineOverview,
                label: this.translate("moreCoreCalendar__calendarButtonsLabel_TimelineOverview"),
                    callback: lang.hitch(this, this._onClick_TimelineOverview),
                    enabled: this.currentMode != "timelineOverview",
                    icon: this.currentMode == "timelineOverview" ? "fas fa-check" : "fas fa-th"
                }, "timeline");
        }

        if (this.allowTimelineDetail) {
            menu.addEntry({
                name: WebcalendarTypes.WebCalendar_ViewModes.timelineDetail,
                label: this.translate("moreCoreCalendar__calendarButtonsLabel_TimelineDetail"),
                callback: lang.hitch(this, this._onClick_TimelineDetail),
                enabled: this.currentMode != "timelineDetail",
                icon: this.currentMode == "timelineDetail" ? "fas fa-check" : "fas fa-th-large"
            }, "timeline");
        }
        if (this.allowTimelineDay) {

            menu.addEntry({
                name: WebcalendarTypes.WebCalendar_ViewModes.timelineDay,
                label: this.translate("moreCoreCalendar__calendarButtonsLabel_TimelineDay"),
                callback: lang.hitch(this, this._onClick_TimelineDay),
                enabled: this.currentMode != "timelineDay",
                icon: this.currentMode == "timelineDay" ? "fas fa-check" : "fas fa-square"
            }, "timeline");
        }

        if (menu.hasGroup("calendar")) menu.addGroup("calendar", this.translate("General_Label_Calendar"), "fas fa-calendar-alt");
        if (menu.hasGroup("timeline")) menu.addGroup("timeline", this.translate("General_Label_Timeline"), "fas fa-stream");
        if (menu.hasGroup(WebcalendarTypes.WebCalendar_ViewModes.listView)) menu.addGroup(WebcalendarTypes.WebCalendar_ViewModes.listView, this.translate("moreCoreCalendar__calendarButtonsLabel_listview"), "fas fa-bars");




        let customGroupCreated = false;
        for (let entry of this.allButtonsRegistry) {
            if (entry.custom === true && entry.showInViewMenu === true) {
                if (!customGroupCreated) {
                    menu.addSeparator();
                    customGroupCreated = true;
                }
                menu.addEntry({
                    label: entry.label,
                    callback: entry.function,
                    icon: entry.iconClass ? entry.iconClass : null
                })
            }
        }

        menu.open(evt);
    }

    setCurrentView(viewname: WebcalendarTypes.WebCalendar_ViewModes) {
        this.setMode(viewname, false);
    }

    getSelectedViewMode(): WebcalendarTypes.WebCalendar_ViewModes {
        return this.currentMode;
    }
    getSelectedViewBehaviour() {
        return this.viewBehaviour;
    }

    getViewButtonByName(key: WebcalendarTypes.WebCalendar_ViewButtonNames): WebcalendarTypes.WebCalender_ViewButton {

        for (let button of this.allButtonsRegistry) {
            if (button.name == key) {
                return button;
            }
        }
        return null;
    }

    ////properties -----------------------------------------------------------------END
    private processSubscriptions(): void {
        topic.subscribe("mainProperties/disableCalButtons", lang.hitch(this, "disableAllButtons"));
        topic.subscribe("mainProperties/enableCalButtons", lang.hitch(this, "enableAllButtons"));
    }

    disableAllButtons(): void {
        for (var i = 0; i < this.allButtonsRegistry.length; i++) {
            var buttonNode = this.allButtonsRegistry[i].nodeName;
            this.UiModder.domAttr.set(this[buttonNode], "disabled", true);
        }

        this.UiModder.domClass.add(this.btnViewSelectMenu, "w3-disabled");
    }

    enableAllButtons(): void {
        for (var i = 0; i < this.allButtonsRegistry.length; i++) {
            var buttonNode: string = this.allButtonsRegistry[i].nodeName;
            this.UiModder.domAttr.remove(this[buttonNode], "disabled");
        }

        this.UiModder.domClass.remove(this.btnViewSelectMenu, "w3-disabled");
    }

    addButton(buttonEntry: WebcalendarTypes.WebCalender_ViewButton): void {
        
        if (!buttonEntry || !buttonEntry.name) return;
        if (typeof (buttonEntry.function) != "function") return;

        buttonEntry.custom = true;

        let index = this.getButtonIndexByName(buttonEntry.name);
        if (index != -1) {
            // TODO: entfernen... oder umbauen
        }

        let name = buttonEntry.name;

        if (buttonEntry.showAsButton) {
            buttonEntry.nodeName = "wcbtn-" + name;

            let button = this.UiModder.domConstruct.create("button",
                {
                    className: "mds-button-base roundest order accentBG mds-hover-bright",
                    innerHTML: buttonEntry.label,
                    id: "wcbtn-" + name
                }, this.customButtonsContainer);
            button.setAttribute("data-cy", "calBtn:wcbtn:" + name);

            if (buttonEntry.iconClass) {
                let icon = this.createFontawesomeIcon(buttonEntry.iconClass, buttonEntry.label ? "&nbsp;" : "");
                this.UiModder.domConstruct.place(icon, button, "first");
            }

            this.hideNode(this.customButtonsContainer, false);

            on(button, "click", buttonEntry.function);
        }

        this.allButtonsRegistry.push(buttonEntry);

    }

    private getButtonIndexByName(name: string): number {
        for (let i = 0; i < this.allButtonsRegistry.length; i++) {
            if (this.allButtonsRegistry[i].name == name) {
                return i;
            }
        }

        return -1;
    }

    

    private _onSelectView(view: string) {

    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.allButtonsRegistry = [];
        ///

        this.setupRange(0, 0, 0, "", "", "");

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.processSubscriptions();
    }



}

export default mdsWidget(Calendar_Buttons);